import React from "react";
import TextInput from "../../../ShareElements/TextInput/SimpleTextInput";
import TextArea from "../../../ShareElements/TextInput/SimpleTextArea";
import Close from "../../../../../../Assets/Images/x.svg";

const MessageModal = (props) => {
  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };
  return (
    <div className="overlay">
      <div onClick={() => props.closeMessage()} className="outline"></div>
      <div className="message-modal">
        <div className="modal-header">
          <img
            onClick={() => props.closeMessage()}
            alt=""
            className="close"
            src={Close}
          />
          <h3 className="modal-title">{translateText("send_message")}</h3>
          <p className="recipient-name">{translateText("to_all_employees")}</p>
        </div>
        <div className="subject-holder">
          <TextInput
            Id="message-all-subject"
            PlaceHolder={translateText("subject")}
            ChangeEvent={() =>
              props.removeError("message-all-subject-label-holder")
            }
            ValidationMessage="Please enter the subject."
          />
        </div>
        <div className="message-holder" id="message-holder">
          <TextArea
            Id="message"
            PlaceHolder={translateText("write_your_message") + " ..."}
            ChangeEvent={() => props.removeError("message-textarea-holder")}
            ClassName={"message-input"}
            ValidationMessage="Please enter the message."
          />
        </div>
        <section className="btn-group">
          <button onClick={() => props.closeMessage()} className="cancel">
            {translateText("cancel")}
          </button>
          <button
            onClick={() => props.validateMessageEntries()}
            className="submit"
          >
            {translateText("submit")}
          </button>
        </section>
      </div>
    </div>
  );
};

export default MessageModal;
